import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import VerifyIdentityModal from "../components/VerifyIdentityModal";

const VerifyIdentityModalPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const returnTo = location.state?.returnTo || "/dashboard";

  return (
    <VerifyIdentityModal
      isOpen={true}
      onClose={() => {
        navigate(returnTo, { replace: true });
      }}
    />
  );
};

export default VerifyIdentityModalPage;
